import { render, staticRenderFns } from "./WelcomePrompt.vue?vue&type=template&id=19708056&scoped=true&"
import script from "./WelcomePrompt.vue?vue&type=script&lang=js&"
export * from "./WelcomePrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19708056",
  null
  
)

export default component.exports